import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// @ts-ignore
import s from './form.css';
import Table from '../Table/Table';
import Collapse, { Panel } from '../../../components/Collapse/Collapse';

const initQuery = [{
  name: '微博金V认证',
  value: 111
}, {
  name: '微博橙V认证',
  value: 222
}, {
  name: '微博蓝V认证',
  value: 333
}, {
  name: '微博一般用户',
  value: 444
}, {
  name: '微信认证账号',
  value: 111
}, {
  name: '微信非认证账号',
  value: 222
}, {
  name: '今日头条认证账号',
  value: 111
}, {
  name: '今日头条非认证账号',
  value: 222
}, {
  name: '知乎优秀回答者',
  value: 111
}, {
  name: '知乎认证回答者',
  value: 222
}, {
  name: '知乎一般用户',
  value: 333
}];


class KOL extends Component {
  state = {
    initQuery
  }

  handleChange (index, type, e) {
    const initQuery = this.state.initQuery
    const value = e.target.value
    initQuery[index][type] = value
    this.setState({
      initQuery: initQuery
    })
  }

  handleClick = () => {
    
    let { onChange, list } = this.props;

    list = this.state.initQuery;

    onChange({}, list);

    // 重置表单
    this.setState({
      initQuery
    })
  }

  handleCenter = (key, val) => {
    const { onChange, center } = this.props;
    onChange({}, {
      center: {
        ...center,
        [key]: val
      }
    });
  }

  remove = (index) => {
    const removeHandle = this.props.removeHandle
    removeHandle && removeHandle(index)
  }

  edit = (index) => {
    const {list} = this.props;
    const item = list[index]
    this.setState({
      editIndex: index,
      name: item.name,
      value: item.value,
      color: item.color
    })
  }

  clear = () => {
    const { onChange } = this.props;
    onChange({}, []);
  }


  render () {
    const {list, center} = this.props;
    const {initQuery} = this.state;
    
    return (
      <Collapse className={s.collapse}>
        <Panel header="图标中心" expand>
          <label>
            X：<input type="text" value={center.x} onChange={(e) => this.handleCenter('x', e.target.value)} />
          </label>
          <hr/>
          <label>
            Y：<input type="text" value={center.y} onChange={(e) => this.handleCenter('y', e.target.value)} />
          </label>
        </Panel>
        <Panel header="数据" expand>
          <div><button onClick={this.clear}>清空数据</button></div>
          {
            initQuery.map((item, index) => (
              <div>
                <input value={item.name} onChange={e=>{this.handleChange(index, 'name', e.target.value)}} />
                <input type="number" value={item.value} onChange={e=>{this.handleChange(index, 'value', e)}} />
              </div>
            ))
          }

          <button onClick={this.handleClick}>设置</button>

          <Table 
            header={() =>
              <tr>
                <th>标签</th>
                <th>值</th>
              </tr>
            }
            body={() => list.map((item, index) => 
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.value}</td>
              </tr>  
            )}
          />

        </Panel>
      </Collapse>
    )
  }
}



export default withStyles(s)(KOL)


// WEBPACK FOOTER //
// src/routes/customChart/components/KOL.js